import VideoLinkProduct from 'features/video-link-product/VideoLinkProduct/VideoLinkProduct';
import { StepChildProps } from '../VideoType';

const TypeSetProduct = ({ videoId, setStep }: StepChildProps) => {
  return <VideoLinkProduct videoId={videoId} />;
};

export default TypeSetProduct;
